export const BadRequest = 400
export const Unauthorized = 401
export const AccessDenied = 403
export const NotFound = 404
export const MethodNotAllowed = 405
export const NotAcceptable = 406
export const Conflict = 409
export const Gone = 410
export const LengthRequired = 411
export const PreconditionFailed = 412
export const UnsupportedMediaType = 415 
export const PreconditionRequired = 428
export const TooManyRequests = 429
export const Exception = 500
export const ServiceUnavailable = 503